import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { getAllArtists } from "../../../api/artistApi";
import { getCountryMap, getStudio, getTermintypen } from "../../../api/commonApi";
import { loadArtistSettings } from "../../../api/localArtistPersistence";
import { saveUserReference } from "../../../api/localAuthPersistence";
import { getStudioSubscriptionStatus } from "../../../api/studioApi";
import { isPublicRoute } from "../../../config/publicRoutes";
import { bootstrapAuth } from "../../auth/authSaga";
import { selectLoggedInArtistID, selectStudioUserID } from "../../auth/authSelector";
import { getArtistToken } from "../../auth/token.saga";
import { pushHistory } from "../../router/routerActions";
import { extractDataFromResponse } from "../../saga-utils/httpInterceptorWrapper";
import {
    LOAD_COMMON,
    loadCommonFailureAction,
    loadCommonSuccessAction,
    loadLoggedArtistSettingsSuccessAction
} from "../commonActions";
function* bootstrapCommon() {
    try {
        const {isArtistLoggedIn, isStudioLoggedIn} = yield* bootstrapAuth()
        const token = yield getArtistToken()
        if (isArtistLoggedIn && token) {
            const artistID = yield select(state => selectLoggedInArtistID(state))
            const {
                artistSettings,
                countryMap,
                termintypMap,
                artistMap,
                studio,
                subscriptionStatus
            } = yield all({
                artistSettings: call(loadArtistSettings, artistID),
                countryMap: call(getCountryMap),
                termintypMap: call(getTermintypen, {token}),
                artistMap: call(getAllArtists, {token}),
                studio: call(getStudio, {token}),
                subscriptionStatus: call(getStudioSubscriptionStatus, {token})
            })
            yield put(loadCommonSuccessAction({
                countryMap: extractDataFromResponse(countryMap)
                , artistMap: extractDataFromResponse(artistMap)
                , termintypMap: extractDataFromResponse(termintypMap)
                , studio: extractDataFromResponse(studio)
                , subscriptionStatus: extractDataFromResponse(subscriptionStatus)
            }))
            yield put(loadLoggedArtistSettingsSuccessAction(artistSettings))

            // Save user reference to localStorage to prevent accidental re-signup
            const userId = yield select(state => selectStudioUserID(state))
            if (userId) {
                yield call(saveUserReference, {userId})
            }


        } else {
            yield put(loadCommonFailureAction())
            // Check if we're on a public route that doesn't require authentication
            const currentPath = window.location.pathname
            
            // Only redirect to login if not on a public route
            if (!isPublicRoute(currentPath)) {
                if (isStudioLoggedIn) {
                    yield put(pushHistory('/login-artist'))
                } else {
                    yield put(pushHistory('/login-studio'))
                }
            }
        }

    } catch (e) {
        console.log(e)
        yield put(loadCommonFailureAction())
        // Check if we're on a public route before redirecting to error page
        const currentPath = window.location.pathname
        
        if (!isPublicRoute(currentPath)) {
            yield put(pushHistory('/error'))
        }
    }
}

export function* watchLoadCommon() {
    yield takeLatest(LOAD_COMMON, bootstrapCommon)
}
